import React, { lazy } from 'react';
import { Route } from 'react-router';
import routes from '../routes';
import Authenticated from '../../components/auth/Authenticated';

const AppVersionListScreen = lazy(() => import('../../screens/AppVersion/AppVersionListScreen'));
const EditAppVersionScreen = lazy(() => import('../../screens/AppVersion/EditAppVersionScreen'));
const UserAppVersionListScreen = lazy(() => import('../../screens/UserAppVersion/UserAppVersionListScreen'));

const appVersionRoutes = [
    <Route
        exact
        key={routes.USER_APP_VERSIONS}
        path={routes.USER_APP_VERSIONS}
        render={() => (
            <Authenticated redirectTo={routes.LOGIN}>
                <UserAppVersionListScreen />
            </Authenticated>
        )}
    />,
    <Route
        exact
        key={routes.APP_VERSION_LIST}
        path={routes.APP_VERSION_LIST}
        render={() => (
            <Authenticated redirectTo={routes.LOGIN}>
                <AppVersionListScreen />
            </Authenticated>
        )}
    />,
    <Route
        exact
        key={routes.APP_VERSION_CREATE}
        path={routes.APP_VERSION_CREATE}
        render={() => (
            <Authenticated redirectTo={routes.LOGIN}>
                <EditAppVersionScreen />
            </Authenticated>
        )}
    />,
    <Route
        exact
        key={routes.APP_VERSION_EDIT}
        path={routes.APP_VERSION_EDIT}
        render={() => (
            <Authenticated redirectTo={routes.LOGIN}>
                <AppVersionListScreen />
            </Authenticated>
        )}
    />,
];

export default appVersionRoutes;
